import { render, staticRenderFns } from "./ReferralHeader.vue?vue&type=template&id=1879343e"
import script from "./ReferralHeader.vue?vue&type=script&lang=js"
export * from "./ReferralHeader.vue?vue&type=script&lang=js"
import style0 from "./ReferralHeader.vue?vue&type=style&index=0&id=1879343e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports